import React from 'react';
import moment from 'moment';

var CellFormatter = function CellFormatter(_ref) {
  var value = _ref.value;

  if (!isNaN(parseFloat(value)) && parseFloat(value).toFixed(countDecimals(value)).toString() === value) {
    return React.createElement("div", {
      style: {
        textAlign: 'right'
      }
    }, value);
  } else if (moment(value, ['M/D/YYYY', 'MM/DD/YYYY', 'M/D/YY', 'MM/DD/YY'], true).isValid()) {
    return React.createElement("div", {
      style: {
        textAlign: 'right'
      }
    }, value);
  } else {
    var date = moment(value, moment.ISO_8601, true);
    if (date.isValid()) return React.createElement("div", {
      style: {
        textAlign: 'right'
      }
    }, date.format('MM/DD/YYYY h:mm:ss A'));
  }

  return value;
};

var countDecimals = function countDecimals(value) {
  var decimals = value.split('.')[1];
  if (decimals) return decimals.length;
  return 0;
};

export default CellFormatter;